// frontend/src/pages/HomePage.js
import React, { useState, useEffect } from 'react';
import Hero from '../components/pages/home/Hero';
import { settingsApi } from '../api/settings';
import { vehiclesApi } from '../api/vehicles';
import { FaShoppingCart, FaCar, FaTools, FaRocket } from 'react-icons/fa';
import VehicleCard from '../components/vehicle/VehicleCard';

function HomePage({ onOpenAIChat }) {
  const [siteContent, setSiteContent] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [featuredVehicles, setFeaturedVehicles] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch site content
        const contentData = await settingsApi.getSiteContent();
        if (contentData) setSiteContent(contentData);

        // Fetch vehicles with a limit (Optimization)
        // We fetch all for now as the API doesn't support 'featured' filter yet, 
        // but we slice it immediately to prevent rendering issues.
        // Ideally, backend should have a /vehicles/featured endpoint.
        const vehiclesData = await vehiclesApi.getAllVehicles();
        
        // Filter for promoted items and limit to 4
        const promoted = vehiclesData
            .filter(v => v.is_promoted && new Date(v.promoted_until) > new Date())
            .slice(0, 4);
            
        setFeaturedVehicles(promoted);

      } catch (err) {
        console.error("Failed to fetch home data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="home-page">
      <Hero 
        onOpenAIChat={onOpenAIChat} 
        headline={siteContent?.hero_headline}
        subheadline={siteContent?.hero_subheadline}
        imageUrl={siteContent?.hero_image_url}
        isLoading={loading} 
      />
      
      {/* --- FEATURED SECTION --- */}
      {featuredVehicles.length > 0 && (
          <section className="bg-gray-50 py-12 border-b border-gray-200">
              <div className="container mx-auto px-4">
                  <div className="flex items-center gap-2 mb-8 justify-center">
                      <FaRocket className="text-red-600 text-2xl animate-pulse" />
                      <h2 className="text-3xl font-bold text-gray-800">Featured Vehicles</h2>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                      {featuredVehicles.map(vehicle => (
                          <VehicleCard key={vehicle.id} vehicle={vehicle} />
                      ))}
                  </div>
              </div>
          </section>
      )}

      <section className="container mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">Our Core Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow">
            <FaShoppingCart className="text-4xl text-primary mx-auto mb-4" />
            <h3 className="font-bold text-xl mb-2">Parts E-commerce</h3>
            <p className="text-gray-600">Find genuine and aftermarket parts for any vehicle.</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow">
            <FaCar className="text-4xl text-primary mx-auto mb-4" />
            <h3 className="font-bold text-xl mb-2">Vehicle Marketplace</h3>
            <p className="text-gray-600">Buy or sell new and used cars securely.</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow">
            <FaTools className="text-4xl text-primary mx-auto mb-4" />
            <h3 className="font-bold text-xl mb-2">Expert Service Booking</h3>
            <p className="text-gray-600">Book workshop, home, or roadside assistance.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;